import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase-config';
import { doc, getDoc, collection, getDocs, query, where } from 'firebase/firestore';


function LmsPackageDetails() {
    const { packageId } = useParams();
    const navigate = useNavigate();

    const [pkg, setPkg] = useState(null);
    const [batches, setBatches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!packageId) {
            setError('No package ID provided');
            setLoading(false);
            return;
        }
        const fetchPackageAndBatches = async () => {
            try {
                // Step 1: Fetch package by ID
                const packageDocRef = doc(db, 'lms_package', packageId);
                const packageDocSnap = await getDoc(packageDocRef);

                if (!packageDocSnap.exists()) {
                    setError('Package not found');
                    setLoading(false);
                    return;
                }

                const packageData = packageDocSnap.data();
                setPkg({ id: packageId, ...packageData });

                // Step 2: Fetch batches one by one if available
                if (packageData.packageContainingBatches?.length > 0) {
                    const batchData = [];

                    for (const batchId of packageData.packageContainingBatches) {
                        const batchDocRef = doc(db, 'lms_batch', batchId);
                        const batchDocSnap = await getDoc(batchDocRef);

                        if (batchDocSnap.exists()) {
                            batchData.push({ id: batchId, ...batchDocSnap.data() });
                        }
                    }

                    setBatches(batchData);
                }

                setLoading(false);
            } catch (err) {
                console.error('Failed to fetch data:', err);
                setError('Failed to fetch package or batches');
                setLoading(false);
            }
        };

        fetchPackageAndBatches();
    }, [packageId]);

    const handleBatchClick = (batchId) => {
        navigate(`/package/${packageId}/${batchId}`);
    };


    if (loading) {
        return (
            <>

                <div className="bg-black min-h-screen text-white font-poppins p-6 flex flex-col items-center">
                    <p>Loading...</p>
                </div>

            </>
        );
    }

    if (error || !pkg) {
        return (
            <>

                <div className="bg-black min-h-screen text-white font-poppins p-6 flex flex-col items-center">
                    <p>{error || 'Package not found'}</p>
                </div>
            </>
        );
    }

    return (
        <>
            <div className="bg-black min-h-screen text-white font-poppins p-6 flex flex-col items-center">
                <div className="max-w-4xl w-full">

                    <div className='text-2xl text-yellow-600 mb-4'>Package Page</div>

                    {/* Package Details */}
                    <h1 className="text-[1.75rem] font-medium leading-9 bg-custom-gradient bg-clip-text text-transparent mb-4">
                        {pkg.packageName}
                    </h1>



                    <div className='flex gap-4 border border-gray-800 rounded-lg'>

                        <div className="w-1/2 h-auto  overflow-hidden p-6">
                            <img
                                src={pkg.packageBanner}
                                alt={pkg.packageName}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="p-6 w-1/2">
                            <div
                                className="text-xl font-normal text-white leading-9 mb-4"
                                dangerouslySetInnerHTML={{ __html: pkg.packageDescription }}
                            />
                            <hr className="w-full border-t border-[rgba(231,233,235,0.3)] mb-4" />
                            <ul className="flex flex-col gap-2 list-none">
                                <li className="flex items-center gap-2 text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                    <span className="w-2 h-2 rounded-full bg-custom-gradient"></span>
                                    Price: ₹{parseFloat(pkg.packagePrice).toLocaleString('en-IN')}
                                </li>
                                <li className="flex items-center gap-2 text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                    <span className="w-2 h-2 rounded-full bg-custom-gradient"></span>
                                    Created: {new Date(pkg.createdAt).toLocaleDateString()}
                                </li>
                                <li className="flex items-center gap-2 text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                    <span className="w-2 h-2 rounded-full bg-custom-gradient"></span>
                                    Updated: {new Date(pkg.updatedAt).toLocaleDateString()}
                                </li>
                                {/* {pkg.packageContent && (
                                <li className="flex items-center gap-2 text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                    <span className="w-2 h-2 rounded-full bg-custom-gradient"></span>
                                    Content: {pkg.packageContent}
                                </li>
                            )} */}
                            </ul>
                        </div>

                    </div>

                    {/* Batches List */}
                    <h2 className="text-[1.75rem] mt-10 font-medium leading-9 bg-custom-gradient bg-clip-text text-transparent mb-4">
                        Included Batches
                    </h2>
                    <div className="flex flex-col gap-4">
                        {batches.length > 0 ? (
                            batches.map((batch) => (
                                <div
                                    key={batch.id}
                                    className="bg-card-bg rounded-xl p-5 flex flex-row gap-6 cursor-pointer hover:scale-[1.02] transition-transform"
                                    onClick={() => handleBatchClick(batch.id)}
                                >
                                    <img
                                        src={batch.batchBanner || "https://logo.gklite.in/anuragaffection.jpg"}
                                        className='w-36 h-auto rounded-lg'
                                        alt=""
                                    />

                                    <div className='flex flex-col gap-2'>
                                        <h3 className="text-[1.5rem] font-medium text-white leading-9">
                                            {batch.batchName || `Batch ${batch.id}`}
                                        </h3>
                                        {batch.batchDescription && (
                                            <div
                                                className="text-[1.2rem] font-normal text-white leading-[2.125rem]"
                                                dangerouslySetInnerHTML={{ __html: batch.batchDescription }}
                                            />
                                        )}
                                        {batch.updatedAt && (
                                            <p className="text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                                Start Date: {new Date(batch.updatedAt).toLocaleDateString()}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                No batches found for this package.
                            </p>
                        )}
                    </div>
                </div>
            </div>

        </>
    );
}

export default LmsPackageDetails;